import styled from '@emotion/styled';
import {Select} from '@mui/material';
import { APP } from 'src/styles/variables';

export const SelectField = styled(Select)<{disabled: boolean}>`
  .MuiSelect-select {
    height: 18px !important;
    min-height: 18px !important;
    ${({disabled}) => disabled && `background-color : ${APP.PALETTE.COMMON.LIGHT_GRAY}`}
  }
`;

export const TextLabelWrapperComponentDiv = styled.div`
  width: 100%;
`;

export const FormHelperTextP = styled.p``;
